import {
    getSingleSubscription,
    getSubscriptions,
} from '../redux/subscription/selectors';
import { SUBSCRIPTION_FETCH_SCOPE, getSubscriptionFetchScope } from './tracking';

const getUIElementType = pageType => `content:${pageType}:element`;

export const providerLegacy = {
    id: CONFIG.tracking.provider,
    product: CONFIG.tracking.provider,
    productTag: 'mypage',
    'spt:engage': CONFIG.tracking.provider.toUpperCase(),
};

export const formatBaseParamsLegacy = pageType => ({
    provider: providerLegacy,
    object: {
        pageId: 'index',
        contentId: 'index',
        name: pageType,
        type: 'Page',
    },
    deployStage: CONFIG.tracking.deployStage,
});

export const formatPageViewEventParamsLegacy = (pageType, customProperties) => ({
    provider: providerLegacy,
    object: {
        pageId: 'index',
        contentId: 'index',
        name: pageType,
        type: 'Page',
        ...customProperties,
    },
    deployStage: CONFIG.tracking.deployStage,
});

/**
 * @param {object} params
 * @param {string} params.id
 * @param {string} [params.url]
 * @param {string} [params.contentId]
 */
export const formatUIEventParamsLegacy = ({ id, url, contentId, ...customProperties }) => ({
    type: 'Engagement',
    provider: providerLegacy,
    object: {
        id,
        url: url || window.location.href,
        '@type': 'UIElement',
        type: getUIElementType(CONFIG.tracking.pageType.myPage),
        contentId: contentId || 'index',
        name: CONFIG.tracking.pageType.myPage,
        ...customProperties,
    },
    action: 'Click',
    deployStage: CONFIG.tracking.deployStage,
});

export const formatFormEventParamsLegacy = ({ type, id }) => ({
    type,
    provider: providerLegacy,
    object: {
        type: 'Form',
        id,
        name: CONFIG.tracking.pageType.myPage,
    },
    deployStage: CONFIG.tracking.deployStage,
});

export const formatUIImpressionEventParamsLegacy = ({ id, ...customProperties }) => ({
    type: 'Impression',
    provider: providerLegacy,
    object: {
        id,
        '@type': 'UIElement',
        type: getUIElementType(CONFIG.tracking.pageType.myPage),
        contentId: 'index',
        name: CONFIG.tracking.pageType.myPage,
        ...customProperties,
    },
    deployStage: CONFIG.tracking.deployStage,
});

const extractProductsFromState = (state, scope) => {
    const subscriptionsList = getSubscriptions(state);
    const singleSubscription = getSingleSubscription(state);

    if (scope === SUBSCRIPTION_FETCH_SCOPE.ALL) {
        const validSubscriptions = subscriptionsList
            .filter(subscription => subscription?.name)
            .map(subscription => subscription.name);

        return validSubscriptions.length ? validSubscriptions.join(' | ') : 'none';
    }

    if (scope === SUBSCRIPTION_FETCH_SCOPE.SINGLE && singleSubscription?.name) {
        return singleSubscription.name;
    }

    return 'none';
};

export const formatActor = (state) => {
    const scope = getSubscriptionFetchScope();
    const base = {
        id: state?.spid?.userId ?? null,
        realm: CONFIG.tracking.spidRealm,
    };

    if (scope === null) return base;

    return {
        ...base,
        subscriptionName: extractProductsFromState(state, scope),
    };
};
